import { c as _c } from "react/compiler-runtime";
import type { PlayInfo } from '@module/apis/client-side/live/type';
import { cn } from '@module/lib/utils';
import { LiveFanRanking } from '@module/svg/icons';
import type { TabList } from '@module/types/broadcast-setting/type';
import getFirstLetterFromNick from '@module/utils/getFirstLetterFromNick';
import type { Dispatch, SetStateAction } from 'react';
interface VipFanListBoxProps {
  playInfo: PlayInfo;
  setStepType: Dispatch<SetStateAction<TabList>>;
}
function VipFanListBox(t0) {
  const $ = _c(15);
  const {
    playInfo,
    setStepType
  } = t0;
  let t1;
  if ($[0] !== setStepType) {
    t1 = () => {
      setStepType?.("rank");
    };
    $[0] = setStepType;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LiveFanRanking className="h-[21px] w-[21px]" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <button onClick={t1}>{t2}</button>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== playInfo.fanList) {
    t4 = playInfo.fanList.map(_temp);
    $[5] = playInfo.fanList;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== setStepType) {
    t5 = <button onClick={() => {
      setStepType?.("rank");
    }} className="mr-1 flex h-[28px] w-[28px] items-center justify-center overflow-hidden rounded-full border border-borderBg02 bg-colorBg14 font-medium text-colorIco18 text-lg">+</button>;
    $[7] = setStepType;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <ul className="ml-3 flex border-l border-l-borderBg08 pl-3">{t4}{t5}</ul>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t6) {
    t7 = <div className="flex h-[42px] border-b border-b-borderBg01 px-[16px] py-[7px]">{t3}{t6}</div>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
function _temp(item, index) {
  if (index > 2) {
    return;
  }
  return <div key={item.userIdx} className={cn("mr-1 flex h-[28px] w-[28px] items-center justify-center overflow-hidden rounded-full border border-borderBg02 bg-colorBg14 text-colorIco13 text-sm", {
    "text-[#139a8e]": index === 0,
    "text-[#f07f07]": index === 1,
    "text-[#e74c3c]": index === 2
  })}>{!item.userProfileImg && getFirstLetterFromNick(item.userNick)}{item.userProfileImg && <img src={`${item.userProfileImg}`} alt="avatar" className="h-[28px] w-[28px] object-cover" />}</div>;
}
export default VipFanListBox;